import { Route, Routes } from "react-router-dom";

import NotFoundPage from "app/router/components/NotFoundPage";
import { getCommunicationRoutes } from "app/router/components/routeGroups/CommunicationRoutes";
import { getDataCollectionRoutes } from "app/router/components/routeGroups/DataCollectionRoutes";
import { getMainRoutes } from "app/router/components/routeGroups/MainRoutes";
import { getMemberRoutes } from "app/router/components/routeGroups/MemberRoutes";
import { getNoticeRoutes } from "app/router/components/routeGroups/NoticeRoutes";
import { getShopManagerRoutes } from "app/router/components/routeGroups/ShopManagerRoutes";
import Home from "pages/home";
import Setting from "pages/setting/SettingPage";

function RouteContent() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      {getMainRoutes()}
      {getNoticeRoutes()}
      {getShopManagerRoutes()}
      {getCommunicationRoutes()}
      {getDataCollectionRoutes()}
      {getMemberRoutes()}
      <Route path="/setting" element={<Setting />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default RouteContent;
